__turbopack_context__.v({
  "close-button": "team-env-banner-module-scss-module__A_nkla__close-button",
  "team-banner": "team-env-banner-module-scss-module__A_nkla__team-banner",
});
